<template>
  <div class="generateApi">
    <template v-if="menuData.length">
      <my-Menu
        class="api-menu"
        width="250"
        :activeMenu="activeMenu"
        menuKey="id"
        activeTextColor="#0087ff"
        backgroundColor="#fff"
        textColor="black"
        :menuData="menuData"
        @selectMenu="selectMenu"
      ></my-Menu>
      <div class="right-view x-padding x-flex-one x-flex-y x-scrollbar-show">
        <div class="x-border-50 x-margin-b">
          <my-head-title :title="active"></my-head-title>
          <div class="x-padding-info">
            <div class="ul-item" v-if="formData.request">
              <my-info-item :title="$t('HT.apiStepThree.path')" :info="domainAnduri"></my-info-item>
              <my-info-item :title="$t('HT.apiStepThree.method')" :info="formData.request.method"></my-info-item>
              <my-info-item :title="$t('HT.apiStepThree.remark')" :info="formData.remark"></my-info-item>
            </div>
          </div>
        </div>
        <div class="x-border-50 x-margin-b">
          <my-head-title :title="$t('HT.apiInfo.title2')"></my-head-title>
          <div class="x-padding" v-if="formData.request">
            <ux-table
              ref="table"
              xborder
              :showPage="false"
              :data="formData.request.parameters || []"
              :columns="columns1"
              :emptyText="$t('HT.nodata')"
              layout="total, sizes, prev, pager, next"
            ></ux-table>

            <!-- <my-table ref="table" xborder :showPage="false" :tableData="formData.request.parameters || []" :columns="columns1"></my-table> -->
          </div>
        </div>
        <div class="x-border-50 x-flex-one">
          <my-head-title :title="$t('HT.generateApi.title')"></my-head-title>
          <div class="x-padding" v-if="formData.response">
            <el-input
              v-model="formData.response.succeeded"
              type="textarea"
              size="small"
              readonly
              :autosize="{ minRows: 10, maxRows: 10 }"
            ></el-input>
          </div>
        </div>
      </div>
    </template>
    <div v-show="isNo" class="x-blank-img"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      domainAnduri: '',
      menuKey: '',
      activeMenu: '', //默认选中
      active: '', // 默认服务
      formData: {},
      id: parseInt(this.$route.query.id),
      menuData: [], //api分组数据
      columns1: [
        // 入参定义表
        {
          label: this.$t('HT.apiStepTwo.paramsName'),
          prop: 'name',
          minWidth: 130,
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepThree.origin'),
          prop: 'position',
          minWidth: 150,
          tooltip: true
        },
        {
          label: this.$t('HT.upgrade.type'),
          width: 130,
          prop: 'type',
          tooltip: true
        },
        {
          label: this.$t('HT.required'),
          width: 130,
          prop: 'required',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            return JSON.stringify(cellValue);
          }
        },
        {
          label: this.$t('HT.default'),
          prop: 'default_value',
          tooltip: true
        },
        {
          label: this.$t('HT.example'),
          prop: 'example',
          tooltip: true
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          width: 300,
          tooltip: true
        }
      ],
      isNo: false
    };
  },
  created() {
    this.getApiMessage(this.id);
  },

  methods: {
    selectMenu(index) {
      this.$api.product.getApiData(index).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
          this.active = res.data.name;
          // this.activeMenu = index;
          let item = res.data.group.domains;
          let arr = [];
          for (let i = 0; i < item.length; i++) {
            if (item[i].envs.includes('RELEASE')) {
              arr.push(item[i].domain + res.data.request.uri);
              this.domainAnduri = arr.join('   |   ');
            } else {
              this.domainAnduri = '';
            }
          }
        }
      });
    },
    // 获取api分组信息
    getApiMessage(id) {
      this.$api.product.getApiMessage(id).then((res) => {
        // 第一个分组默认选中

        const result = res.data.map((item) => {
          return {
            menuName: item.group_name,
            // 转换成字符串格式  menu那边的Index需要字符串格式
            id: item.group_id + '',
            child: item.api_list.map((child) => {
              return {
                menuName: child.name,
                id: child.id + ''
              };
            }),
            formData: item.api_list
          };
        });
        this.menuData = result;

        if (!result.length) {
          this.isNo = true;
        } else {
          // 默认选中子列表的的第一项
          this.activeMenu = result[0].child[0].id + '';
          this.selectMenu(result[0].child[0].id);
        }
      });
    }
  }
};
</script>

<style lang="scss">
.generateApi {
  display: flex;
  height: 100%;
  .x-flex-one {
    flex-wrap: nowrap;
  }
  .ul-item {
    display: flex;
    flex-wrap: wrap;

    .info-item {
      width: 50%;
    }
  }

  .right-view {
    width: 0;
  }
}

.api-menu {
  background-color: red;
  margin: 20px 0 0 20px;
  height: calc(100% - 40px);

  &.x-sidebar-menu .x-default-sidebar .el-menu--inline .el-menu-item {
    background-color: #fff !important;
  }

  &.x-sidebar-menu .x-default-sidebar .el-menu--inline .el-menu-item:hover {
    color: #0087ff !important;
  }

  &.x-sidebar-menu .x-default-sidebar .el-submenu.is-active .el-submenu__title {
    background-color: #fff !important;
  }

  &.x-sidebar-menu .x-default-sidebar .el-menu--inline .el-menu-item {
    padding: 0 24px 0 70px !important;
  }

  &.x-sidebar-menu .x-default-sidebar.menu-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: rgba(221, 222, 224);
  }
  &.x-sidebar-menu .x-default-sidebar.menu-scrollbar::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: rgba(215, 221, 231);
  }
}
</style>
